module.exports = __webpack_public_path__ + "static/media/PoweredByPrestoIcon.a35caac4.png";